<app-navbar></app-navbar>

<div class="min-h-screen bg-[#F7F5F2] text-[#3A2A25] relative overflow-hidden pt-20 sm:pt-24">
  <!-- Botanical Decoration (Top Left) -->
  <div class="absolute -top-6 -left-6 sm:-top-12 sm:-left-12 w-32 h-32 sm:w-64 sm:h-64 md:w-96 md:h-96 opacity-40 sm:opacity-60 pointer-events-none z-0">
    <app-lazy-image src="amla-top-left.jpg" alt="Amla Branch" imageClass="w-full h-full object-contain mix-blend-multiply aspect-square transform -rotate-12" [useLqip]="false"></app-lazy-image>
  </div>

  <!-- Botanical Decoration (Bottom Right) -->
  <div class="absolute -bottom-6 -right-6 sm:-bottom-12 sm:-right-12 w-40 h-40 sm:w-80 sm:h-80 md:w-[30rem] md:h-[30rem] opacity-40 sm:opacity-60 pointer-events-none z-0">
     <app-lazy-image src="amla-bottom-right.png" alt="Ashwagandha Root" imageClass="w-full h-full object-contain mix-blend-multiply aspect-square transform rotate-12" [useLqip]="false"></app-lazy-image>
  </div>

  <!-- MAIN WRAPPER -->
  <div class="relative z-10 max-w-7xl mx-auto px-6 space-y-8 sm:space-y-24 pb-12">

    <!-- HERO SECTION -->
    <section class="relative -mx-6 sm:mx-0 min-h-[60svh] sm:min-h-0 sm:h-[80vh] py-8 sm:py-12 sm:rounded-2xl overflow-hidden sm:shadow-xl flex items-center justify-center group bg-[#111]">
      <!-- Desktop Background -->
      <img src="home-page.png" alt="Hero" fetchpriority="high" class="hidden sm:block absolute inset-0 w-full h-full object-cover scale-105 transition-transform duration-[3s] group-hover:scale-110" />

      <!-- Mobile Background -->
      <img src="home-page-vertical.png" alt="Hero Mobile" fetchpriority="high" class="block sm:hidden absolute inset-0 w-full h-full object-cover object-center" />

      <!-- Overlay (Now on both mobile and desktop) -->
      <div class="absolute inset-0 bg-black/40 pointer-events-none"></div>

      <!-- Hero Content -->
      <div class="relative z-10 text-center px-4 flex flex-col justify-center items-center max-w-3xl space-y-3 sm:space-y-6 animate-fade-in-up w-full">
        <p class="uppercase tracking-[0.25em] sm:tracking-[0.3em] text-[10px] sm:text-xs text-white/90 sm:text-[#A46A3F] font-bold">
          Handcrafted Ayurveda
        </p>

        <h1 class="text-4xl sm:text-7xl font-serif text-white leading-tight drop-shadow-md sm:drop-shadow-lg">
          Pure Herbs.<br />
          <span class="italic sm:not-italic">Pure You.</span>
        </h1>

        <p class="text-[13px] sm:text-xl text-white/90 italic font-serif drop-shadow-sm max-w-[260px] sm:max-w-none px-4">
          Aarvya blends timeless herbal wisdom with modern quality standards to support everyday wellness rituals naturally.
        </p>

        <div class="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-5 pt-4 sm:pt-6 w-full sm:w-auto">
          <button (click)="scrollToProducts()"
            class="w-[80%] sm:w-auto px-6 py-2.5 sm:py-3.5 rounded-full bg-[#A46A3F] text-white text-[10px] sm:text-xs uppercase tracking-widest hover:bg-[#8C5632] transition-all shadow-lg border border-transparent hover:shadow-xl">
            Shop Herbs
          </button>

          <a routerLink="/about-us"
            class="text-white text-[10px] sm:text-xs uppercase tracking-widest border-b border-white/40 hover:border-white transition-all py-1 sm:py-3 hover:text-[#D4B896]">
            Our Story
          </a>
        </div>
      </div>
      
      <!-- Scroll Indicator -->
      <div class="hidden sm:block absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce opacity-70 pointer-events-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
        </svg>
      </div>
    </section>
    



    <!-- SEARCH & SORT -->
    <section class="space-y-8 animate-fade-in" *ngIf="searchQuery">
      
      <!-- Search Status -->
      <div class="flex flex-col items-center gap-2">
         <p class="text-[#7A6E69] font-serif italic text-sm">Showing results for</p>
         <h2 class="text-2xl font-serif text-[#3A2A25]">"{{ searchQuery }}"</h2>
         <button [routerLink]="['/home']" [queryParams]="{q: null}" queryParamsHandling="merge" class="text-xs uppercase tracking-widest text-[#A46A3F] hover:text-[#3A2A25] transition-colors mt-2">
           Clear Search
         </button>
      </div>
    </section>

    <!-- PRODUCT GRID -->
    <section id="products-section" class="min-h-[400px]">
      <ng-container *ngIf="products$ | async as products; else loading">

        <div *ngIf="products.length > 0; else noProducts"
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
          <!-- PRODUCT CARD -->
          <div *ngFor="let product of products; let i = index"
            class="bg-[#FBF9F7] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 group flex flex-col h-full border border-[#E5DDD5]/60 hover:-translate-y-1 animate-fade-in-up"
            [style.animationDelay]="i * 100 + 'ms'">
            
            <!-- Image -->
            <div class="aspect-[4/5] overflow-hidden cursor-pointer relative bg-[#F7F5F2] shimmer"
              [routerLink]="['/product', product.id]">
              <img [src]="getImageUrl(product.image)" [alt]="product.name" loading="lazy"
                class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1.5s] ease-out" />
              
              <!-- Badges -->
              <div class="absolute top-3 left-3 flex flex-col gap-2">
                 <span *ngIf="product.discount > 0" class="bg-[#A46A3F] text-white text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm shadow-sm">
                   -{{ product.discount | number:'1.0-0' }}%
                 </span>
                 <span *ngIf="!product.isInStock" class="bg-red-500 text-white text-[10px] uppercase tracking-widest px-2 py-1 rounded-sm shadow-sm">
                   Sold Out
                 </span>
               </div>

              <!-- Wishlist Button -->
              <button (click)="toggleWishlist(product, $event)"
                class="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/80 backdrop-blur-sm border border-white/20 text-[#7A6E69] hover:text-red-500 hover:bg-white transition-all shadow-sm z-20"
                [class.text-red-500]="wishlistService.isInWishlist(product.id)">
                <svg xmlns="http://www.w3.org/2000/svg" [attr.fill]="wishlistService.isInWishlist(product.id) ? 'currentColor' : 'none'" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                   <path stroke-linecap="round" stroke-linejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                 </svg>
              </button>
            </div>

            <!-- Content -->
            <div class="p-5 space-y-3 flex flex-col flex-1">
              <div class="flex-1 space-y-2">
                <div class="flex justify-between items-start">
                  <h3 class="font-serif text-lg text-[#3A2A25] group-hover:text-[#A46A3F] transition-colors leading-tight">
                    {{ product.name }}
                  </h3>
                  <div class="flex items-center gap-1">
                    <div class="flex text-[#A46A3F]">
                      <span *ngFor="let star of [1,2,3,4,5]" class="text-xs">
                        {{ star <= (product.rating || 0) ? '★' : '☆' }}
                      </span>
                    </div>
                    <span class="text-[10px] text-[#7A6E69] font-medium" *ngIf="product.rating > 0">
                      ({{ product.rating }})
                    </span>
                  </div>
                </div>

                <div [innerHTML]="product.description" class="text-sm text-[#5C504B]/80 line-clamp-2 leading-relaxed"></div>

              </div>

              <div class="flex justify-between items-center pt-4 border-t border-[#E5DDD5]/50 mt-auto">
                <div class="flex flex-col">
                  <span class="font-bold text-[#2C1F1A] text-lg">
                    {{ getDiscountedPrice(product) | currency:'INR' }}
                  </span>
                  <span *ngIf="product.discount > 0" class="text-xs text-[#7A6E69] line-through decoration-red-500/30">
                     {{ product.price | currency:'INR' }}
                  </span>
                </div>

                <button (click)="addToCart(product, $event)" [disabled]="!product.isInStock"
                  class="px-5 py-2 text-xs uppercase tracking-widest rounded-full bg-[#A46A3F] text-white hover:bg-[#8C5632] transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed">
                  {{ product.isInStock ? 'Add to Cart' : 'Sold Out' }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- EMPTY -->
        <ng-template #noProducts>
          <div class="text-center py-20 space-y-4 animate-fade-in">
            <div class="text-4xl">🌱</div>
            <h3 class="text-2xl font-serif text-[#3A2A25]">
              No Rituals Found
            </h3>
            <p class="text-[#7A6E69]">
              Fresh herbal treasures are coming soon.
            </p>
          </div>
        </ng-template>
      </ng-container>

      <!-- LOADING -->
      <ng-template #loading>
        <div class="flex justify-center py-20">
          <div class="w-10 h-10 border-2 border-[#A46A3F] border-t-transparent rounded-full animate-spin"></div>
        </div>
      </ng-template>
    </section>

    <!-- NEWSLETTER -->
    <section class="bg-[#2A1D19] rounded-2xl py-16 px-6 text-center text-white space-y-6 shadow-2xl relative overflow-hidden">
      <!-- Decoration -->
      <div class="absolute -top-20 -right-20 w-64 h-64 opacity-5 pointer-events-none">
         <img src="amla-top-left.jpg" class="w-full h-full object-contain invert mix-blend-overlay">
      </div>

      <div class="relative z-10 space-y-6">
        <h2 class="text-3xl sm:text-4xl font-serif">
           Join the Aarvya Circle
        </h2>

        <p class="text-[#CFC5BF] italic max-w-xl mx-auto font-serif text-lg">
           "Receive early access, botanical rituals, and Ayurvedic wisdom in your inbox."
        </p>

        <div class="flex flex-col sm:flex-row justify-center gap-4 pt-4 max-w-lg mx-auto w-full">
           <input [(ngModel)]="email" name="email" placeholder="Enter your email address"
              class="px-6 py-3.5 rounded-full w-full bg-white/10 border border-white/20 outline-none focus:border-[#A46A3F] transition-all text-white placeholder:text-white/40" />

           <button (click)="subscribe()"
              class="px-10 py-3.5 rounded-full bg-[#A46A3F] hover:bg-[#8C5632] transition-all shadow-lg uppercase tracking-widest text-xs font-bold whitespace-nowrap">
              Subscribe
           </button>
        </div>
        <p class="text-[10px] text-[#CFC5BF]/60 uppercase tracking-widest pt-2">Respect for your privacy, always.</p>
      </div>
    </section>

  </div>
</div>
